const AnswerReview = {
  List: "/Tables/AnswerReview/List",
  Info: "/Tables/AnswerReview/Info",
  Export: "/Tables/AnswerReview/Export",
};

export default {
  AnswerReview,
};
